import { useState, useEffect } from "react";
import Translate from "../../utils/Translate";
import { useApi } from "../../utils/Api";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

export function FinalExamLockedTextSetting({ setIsLoading }) {
  const [swedish, setSwedish] = useState("");
  const [english, setEnglish] = useState("");
  const [french, setFrench] = useState("");

  const [oldSwedish, setOldSwedish] = useState("");
  const [oldEnglish, setOldEnglish] = useState("");
  const [oldFrench, setOldFrench] = useState("");

  const hasChanges = swedish !== oldSwedish || english !== oldEnglish || french !== oldFrench;

  const [selectedLanguage, setSelectedLanguage] = useState("");

  const languageMap = {
    swedish: { value: swedish, setter: setSwedish, label: "LanguageCodeEnum_Swedish" },
    english: { value: english, setter: setEnglish, label: "LanguageCodeEnum_English" },
    french: { value: french, setter: setFrench, label: "LanguageCodeEnum_French" },
  };

  const activeLanguage = languageMap[selectedLanguage] || { value: "", setter: () => {}, label: "" };

  const api = useApi();

  useEffect(() => {
    async function fetchData() {
      const langCode = parseInt(localStorage.getItem("lang"), 10);
      const defaultLang = getDefaultSelectedLanguage(langCode);
      setSelectedLanguage(defaultLang);

      await getFinalExamLockedTexts();
    }
    fetchData();
  }, []);

  async function getFinalExamLockedTexts() {
    setIsLoading(true);
    let response = null;
    try {
      response = await api.fetch(
        `${import.meta.env.VITE_MAIN_URL}dataIdSettings/elearning/finalexamlockedtexts`,
        false,
        "GET",
      );
      if (response.isSuccessful) {
        setSwedish(response.swedish);
        setEnglish(response.english);
        setFrench(response.french);

        setOldSwedish(response.swedish);
        setOldEnglish(response.english);
        setOldFrench(response.french);
      }
    } finally {
      setIsLoading(false);
    }
  }

  async function postFinalExamLockedTexts() {
    setIsLoading(true);
    let response = null;
    try {
      let reqObj = { swedish: swedish, english: english, french: french };

      response = await api.fetch(
        `${import.meta.env.VITE_MAIN_URL}dataIdSettings/elearning/finalexamlockedtexts`,
        reqObj,
        "POST",
      );
      if (response.isSuccessful) {
        setSwedish(response.swedish);
        setEnglish(response.english);
        setFrench(response.french);

        setOldSwedish(response.swedish);
        setOldEnglish(response.english);
        setOldFrench(response.french);
      }
    } finally {
      setIsLoading(false);
    }
  }

  function getDefaultSelectedLanguage(languageCode) {
    switch (languageCode) {
      case 29:
        return "swedish";
      case 9:
        return "english";
      case 12:
        return "french";
      default:
        return "swedish";
    }
  }

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel>{Translate.get("Language")}</InputLabel>
        <Select
          value={selectedLanguage}
          label={Translate.get("Language")}
          onChange={(e) => setSelectedLanguage(e.target.value)}
        >
          <MenuItem value={"swedish"}>{Translate.get("LanguageCodeEnum_Swedish")}</MenuItem>
          <MenuItem value={"english"}>{Translate.get("LanguageCodeEnum_English")}</MenuItem>
          <MenuItem value={"french"}>{Translate.get("LanguageCodeEnum_French")}</MenuItem>
        </Select>
      </FormControl>

      {selectedLanguage && (
        <TextField
          fullWidth
          value={activeLanguage.value}
          onChange={(e) => activeLanguage.setter(e.target.value)}
          multiline={true}
          minRows={4}
          label={Translate.get(activeLanguage.label)}
          slotProps={{
            htmlInput: {
              maxLength: 300,
            },
          }}
          style={{ marginTop: "1em" }}
        />
      )}

      <Button
        variant="outlined"
        style={{ marginTop: "1em" }}
        disabled={!hasChanges}
        onClick={async () => await postFinalExamLockedTexts()}
      >
        {Translate.get("Save")}
      </Button>
    </div>
  );
}
